import { DELETE } from "../APiHelper/API"


export const deleteMessageFromTeam = (message_id, onSuccess, onError) => {

    DELETE(`/api/v1/conversations/delete_message_for_team/${message_id}`, onSuccess, onError)
}